import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import * as _ from 'lodash';

import {AuthenticationService} from '../services/authentication.service';

@Directive({
  selector: '[appIsAuthorized]'
})
export class IsAuthorizedDirective {

  constructor(
    private authenticationService: AuthenticationService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {
  }

  @Input()
  set appIsAuthorized(permission: string) {
    const user = this.authenticationService.getUser();
    const permissions = _.isEmpty(user) ? [] : user.permissions;

    if (!permission || permissions.includes(permission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
